import { EBannerSize } from '@/app/models/banners.model';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-skeleton-banner',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonBannerComponent {
  isHorizontal = input<boolean>(false);
  bannerSize = input<EBannerSize>();

  bannerSizeLocal = signal<EBannerSize>(EBannerSize.SKY_SCRAPPER);
  width = signal<number>(0);
  height = signal<number>(0);

  ngOnInit(): void {
    this.bannerSizeLocal.set(
      this.isHorizontal()
        ? this.bannerSize() ?? EBannerSize.CUSTOME
        : this.bannerSize() ?? EBannerSize.SKY_SCRAPPER
    );

    if (!this.isHorizontal()) {
      this.width.set(Number(this.bannerSizeLocal().split('x')[0]));
      this.height.set(Number(this.bannerSizeLocal().split('x')[1]));
    }

    if (this.isHorizontal()) {
      const newWidth = Number(this.bannerSizeLocal().split('x')[0]);
      const isCustome = this.bannerSizeLocal().split('x')[0] === 'auto';

      this.width.set(isCustome ? 120 : newWidth);
      this.height.set(Number(this.bannerSizeLocal().split('x')[1]));
    }
  }
}
